import React, { useState } from 'react'
import { Button, Divider, Form, Input, Tooltip, notification, FormInstance } from 'antd'
import styled from 'styled-components'

import { faArrowUpRightFromSquare, faTrash, faUserPlus } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { txt } from '../../../locales/i18n'
import * as NotificationService from '../../../services/bb-api/notification'

export const UserSelector = (props: { form: FormInstance }) => {
	const [search, setSearch] = useState<any>(null)
	const [loading, setLoading] = useState(false)

	const searchHandler = async (add: (value: unknown) => void) => {
		const users = props.form.getFieldValue(['content', 'users']) ?? []

		const exists = users.some((user: { id: number; email: string }) => {
			return user.email === search || String(user.id) === search
		})

		if (exists) {
			const message = txt('global.already selected')
			return notification.warn({ message, description: search })
		}

		setLoading(true)

		try {
			const user = await NotificationService.getUser(search)
			add(user)

			setSearch('')
		} catch (error) {
			if (error instanceof Error) {
				if (error.message === 'user has no tokens') {
					const message = txt('global.no user push tokens')
					return notification.warn({ message, description: search })
				}

				if (error.message === 'not found') {
					const message = txt('global.not found')
					return notification.warn({ message, description: search })
				}
			}

			const message = txt('notification.unknown error')
			return notification.error({ message, description: search })
		} finally {
			setLoading(false)
		}
	}

	const getUserId = (key: number) => {
		const userIdInput = document.getElementById(`content_users_${key}_id`) as HTMLInputElement
		const userId = userIdInput?.value ?? null
		return userId
	}

	return (
		<Form.List name={['content', 'users']}>
			{(fields, { add, remove }) => (
				<>
					<InputRow>
						<Input
							placeholder={txt('global.email') + ' / ' + txt('global.user id')}
							allowClear
							value={search}
							onChange={({ target }) => setSearch(target.value)}
						/>

						<Button type="primary" onClick={() => searchHandler(add)} loading={loading}>
							<FontAwesomeIcon icon={faUserPlus} />
						</Button>
					</InputRow>

					{fields.length !== 0 && (
						<>
							<Divider />

							<UsersContainer>
								<span>{txt('global.email')}</span>
								<span>{txt('global.name')}</span>
								<span>{txt('global.user id')}</span>
								<span />
								<span />

								{fields.map(({ key, name, ...restField }) => (
									<React.Fragment key={key}>
										<Tooltip title={txt('global.email')}>
											<Form.Item noStyle name={[name, 'email']} {...restField}>
												<Input size="small" placeholder="Aa" bordered={false} disabled />
											</Form.Item>
										</Tooltip>

										<Tooltip title={txt('global.name')}>
											<Form.Item noStyle name={[name, 'username']} {...restField}>
												<Input size="small" placeholder="Aa" bordered={false} disabled />
											</Form.Item>
										</Tooltip>

										<Tooltip title={txt('global.user id')}>
											<Form.Item noStyle name={[name, 'id']} {...restField}>
												<Input className="user-id" size="small" placeholder="Aa" bordered={false} disabled />
											</Form.Item>
										</Tooltip>

										<Tooltip title={txt('global.user')}>
											<Button type="link" href={'/users/' + getUserId(restField.fieldKey)}>
												<FontAwesomeIcon icon={faArrowUpRightFromSquare} />
											</Button>
										</Tooltip>

										<Tooltip title={txt('global.delete')}>
											<Button type="text" danger onClick={() => remove(name)}>
												<FontAwesomeIcon icon={faTrash} />
											</Button>
										</Tooltip>
									</React.Fragment>
								))}
							</UsersContainer>
						</>
					)}
				</>
			)}
		</Form.List>
	)
}

const InputRow = styled.div`
	display: flex;
	gap: 1rem;
`

const UsersContainer = styled.div`
	display: grid;
	grid-template-columns: 2fr 2fr 1fr auto auto;
	gap: 0.4rem 1rem;
	align-items: center;
`
